/* eslint-disable import/no-unresolved */
import React from "react";
import { ChangePassword } from "../../components/admin/change-password";
export function ChangePass() {
  return (
    <React.Fragment>
      <div className="ecommarce-dashboard">
        <ChangePassword />
      </div>
    </React.Fragment>
  );
}